<script>
import { defineComponent, inject, ref, reactive, computed, onMounted } from 'vue';

// Vue Components
import TheHeader from './components/TheHeader.vue';
import TheFooter from './components/TheFooter.vue';
import Slider from './components/Slider.vue';
import PageTit from './components/PageTit.vue';
import PageNav from './components/PageNav.vue';
import GmapIframe from './components/GmapIframe.vue';
import Accordion from './components/Accordion.vue';
import StoryPeopleAccordion from './components/StoryPeopleAccordion.vue';
import LocationVisitMap from './components/LocationVisitMap.vue';
import Loading from './components/Loading.vue';
import TopNews from './components/TopNews.vue';
import NewsArchive from './components/NewsArchive.vue';
import NewsSingle from './components/NewsSingle.vue';

// Node Modules
const WOW = require('wow.js');
const VueScrollTo = require('vue-scrollto');

export default defineComponent({
    components: {
        TheHeader,
        TheFooter,
        Slider,
        PageTit,
        PageNav,
        GmapIframe,
        Accordion,
        StoryPeopleAccordion,
        LocationVisitMap,
        Loading,
        TopNews,
        NewsArchive,
        NewsSingle,
    },
    setup() {
        const mq = inject(['mq']);

        const develop = false; //開発環境かどうか
        const rootPath = develop ? 'https://197.test55.net' : 'https://hotelfaro.jp'; //ルートパス

        const headerH = ref(0); //ヘッダーの高さ
        
        // サイトマップ
        const siteMap = reactive({
            story: {
                name: 'STORY',
                nameJa: 'FAROについて',
                url: '/story/',
            },
            stay: {
                name: 'STAY',
                nameJa: '客室について',
                url: '/stay/',
            },
            toka: {
                name: 'CAFE & RESTAURANT',
                nameJa: 'お食事について',
                url: '/toka/',
            },
            facility: {
                name: 'FACILITIES',
                nameJa: '施設案内',
                url: '/facility/',
            },
            location: {
                name: 'LOCATION',
                nameJa: 'アクセス・周辺情報',
                url: '/location/',
            },
            news: {
                name: 'NEWS',
                nameJa: 'お知らせ',
                url: '/news/',
            },
            faq: {
                name: 'FAQ',
                nameJa: 'よくあるご質問',
                url: '/faq/',
            },
            contact: {
                name: 'CONTACT',
                nameJa: 'お問い合わせ',
                url: '/contact/',
            },
        });
        
        // SNSリスト
        const snsList = reactive({
            instagram: {
                name: 'Instagram',
                url: 'https://www.instagram.com/hotelfaro_manazuru/',
            },
        });

        // ホテル情報
        const information = reactive({
            zipCode: '〒259-0201',
            address: '神奈川県足柄下郡真鶴町真鶴1374-1',
            fax: '0465-46-6771',
            reservation: {
                name: 'RESERVATION',
                nameJa: 'ご宿泊予約',
                url: 'https://go-bluesky-as.reservation.jp/hotels/hotelfaro/',
            }
        });

        // 色管理
        const colors = reactive({
            base: '#333',
            baseDark: '#000',
            key: '#697e75',
            bg: '#f1f1ea',
        });

        // ページID
        const pageId = computed(() => {
            const url = new URL(window.location.href); //URLを取得
            const pathArray = url.pathname.split('/') // スラッシュ区切りで配列に格納

            // componentsの場合facilityを当てる
            if (pathArray[1] === 'components.php') pathArray[1] = 'facility';

            // 2番目に値があればそれを、なければfrontpageを返す
            return pathArray[1] != '' && 'index.php' ? pathArray[1] : 'frontpage';
        });
        
        // wow.js 初期化
        const wowInit = () => {
            const wow = new WOW({
                offset: mq.mdMinus ? 0 : 100, //SP : PC
                animateClass: 'animate__animated'
            });
            wow.init();
        }

        // ヘッダーの高さを取得
        const getHeaderH = (height) => {
            headerH.value = height;
        }

        /**
         * スクロール関数
         * @var {string} id スクロールしたい要素のid(#含めない)
        */
        const scroll = (id) => {
            VueScrollTo.scrollTo(`#${id}`, 500, {
                offset: -headerH.value,
            });
        }

        /**
         * sessionを使ったアンカーリンク
         * 
         * @var {string} url ページのURL
         * @var {string} id スクロールしたい要素のid(#含めない)
        */
        const anchorLink = (url, id) => {
            // ページ内にidの要素がある場合はスクロール
            if (document.getElementById(id)) {
                scroll(id);
            
            // ない場合はidをセッションに保存してページ遷移
            } else {
                window.sessionStorage.setItem(['anchor'], [id]);
                window.location.href = url;
            }
        }

        // sessionにアンカーリンクのキーがあればページ読み込み時にスクロール
        const loadScroll = () => {
            // セッションのアンカーリンクを取得
            const id = window.sessionStorage.getItem(['anchor']);
            if (!id) return; //なければ終了

            window.onload = () => {
                scroll(id); //スクロール
                window.sessionStorage.removeItem(['anchor']); //セッション削除
            }
        }
        
        onMounted(() => {
            wowInit();
            loadScroll();
        })

        return {
            rootPath,
            mq,
            headerH,
            siteMap,
            snsList,
            information,
            colors,
            pageId,
            getHeaderH,
            anchorLink
        }
    }
})
</script>